<div class="page-header--container {{isCurveGray ? 'grey--curve': ''}} {{isCurveWhite ? 'white--curve': ''}}" [ngStyle]="pageHeaderStyle">
    <div class="content--wrapper">
        <a class="{{isAboutUs ? 'about-us': ''}}" routerLink="/home">
            <i class="fas fa-chevron-left"></i>
            <span>{{language.back}}</span>
        </a>
        <h1 class="{{isAboutUs ? 'about-us': ''}}">{{header}}</h1>
    </div>
</div>